import { styled, Switch } from "@mui/material";

export const StyledSwitch = styled(Switch)(({ theme }) => `
  width: 28px;
  height: 15px;
  padding: 0;
  display: flex;
  &:active {    
    & .MuiSwitch-switchBase.Mui-checked {
      transform: translateX(9px);
    }
  }
  & .MuiSwitch-switchBase {
    padding: 2px;
    &.Mui-checked {
      transform: translateX(12px);
      & + .MuiSwitch-track {
        opacity: 1;
        background-color: ${theme.palette.success.main};
        border: 1px solid ${theme.palette.success.main};

      }
      & .MuiSwitch-thumb {
        opacity: 1;
        background-color: ${theme.palette.common.white};
      }
    }
  }
  & .MuiSwitch-thumb {
    background-color: ${theme.palette.common.white};
    box-shadow: 0 2px 4px 0 rgb(0 35 11 / 20%);
    width: 11px;
    height: 11px;
    border-radius: 6px;
    transition: ${theme.transitions.create(["width"])};
    transition-duration: 200;
  }
  & .MuiSwitch-track {
    border: 1px solid ${theme.palette.grey[600]};
    background-color: ${theme.palette.grey[600]};
    border-radius: 16px;
    opacity: 1;
    box-sizing: border-box;
  };
`
);
